import { WebsiteAppTab } from '../../components/tabs/websiteApp/WebsiteAppTab';

const WebsitePage = ({ handleClose, chooseAction }) => {
  return <WebsiteAppTab handleClose={handleClose} chooseAction={chooseAction} />;
};

export default WebsitePage;
